import { resolveForumScope } from './forumPermissions';

/** Build display list for forum info panel — shows effective (narrowest) scope only. */
export function getForumParticipantDisplayList(forum) {
  if (!forum) return [];

  const scope = resolveForumScope(forum);
  const entries = [];

  if (scope === 'individual') {
    (forum.ForumMembers || [])
      .filter((member) => member.role === 'participant')
      .forEach((member) => {
        const name = member.CorporateUser?.full_name?.trim();
        if (name) entries.push({ id: `user-${member.user_id}`, name, type: 'user' });
      });
    return entries;
  }

  if (scope === 'sub_department') {
    (forum.ForumSubDepartments || [])
      .filter((item) => item.is_participant !== false)
      .forEach((item) => {
        const name = item.SubDepartment?.name?.trim();
        if (name) entries.push({ id: `subdept-${item.sub_department_id}`, name, type: 'org' });
      });
    return entries;
  }

  if (scope === 'department') {
    (forum.ForumDepartments || [])
      .filter((item) => item.is_participant !== false)
      .forEach((item) => {
        const name = item.Department?.name?.trim();
        if (name) entries.push({ id: `dept-${item.department_id}`, name, type: 'org' });
      });
    return entries;
  }

  if (scope === 'branch') {
    (forum.ForumBranches || [])
      .filter((item) => item.is_participant !== false)
      .forEach((item) => {
        const name = item.Branch?.name?.trim();
        if (name) entries.push({ id: `branch-${item.branch_id}`, name, type: 'org' });
      });
  }

  return entries;
}
